import { FunctionComponent, useEffect, useRef } from 'react';
import Checkbox from 'components/UI/V3/Forms/Checkbox';
import styles from './SaveCustomPriceCheckbox.module.scss';
import clsx from 'clsx';
import { isSameMoney } from '../utils/bookingCustomPrices';

interface Props {
    checked?: boolean;
    disabled?: boolean;
    className?: string;
    currentPrice?: number;
    defaultPrice?: number;
    onChange?: (checked: boolean) => void;
}

export const SaveCustomPriceCheckbox: FunctionComponent<Props> = ({
    checked = false,
    disabled,
    className,
    currentPrice,
    defaultPrice,
    onChange
}) => {
    const matchesDefault = defaultPrice != null && isSameMoney(currentPrice, defaultPrice);
    const isDisabled = !!disabled || matchesDefault;
    const isChecked = checked && !matchesDefault;
    const onChangeRef = useRef(onChange);
    onChangeRef.current = onChange;

    useEffect(() => {
        if (matchesDefault && checked) {
            onChangeRef.current?.(false);
        }
    }, [matchesDefault, checked]);

    return (
        <div
            className={clsx(styles.container, className, {
                [styles.disabled]: isDisabled
            })}
        >
            <Checkbox
                label="Save this custom price for this pet"
                checked={isChecked}
                onChange={value => {
                    if (!isDisabled) onChange?.(value);
                }}
            />
        </div>
    );
};

export default SaveCustomPriceCheckbox;
